import { createGlobalStyle } from "styled-components";

import NotoSansKrBold from "../static/fonts/NotoSansKR-Bold.otf";
import NotoSansKrRegular from "../static/fonts/NotoSansKR-Regular.otf";

export const GlobalFont = createGlobalStyle`
  @font-face {
    font-family: 'BOLD';
    src: url(${NotoSansKrBold});
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'REGULAR';
    src: url(${NotoSansKrRegular});
    font-weight: 300;
    font-style: normal;
  }

`;
